import * as angular from "angular";
import * as _ from "lodash";

declare let Intercom: any;

function intercomProvider(): any {

  this.initConfigure = function (appId, locale, isDefaultLauncher) {
    let config: any = {
      app_id: appId, // Intercom Test app_id - YOURAPPID
      custom_launcher_selector: '#intercom_button',
      language_override: locale
    };

    if (isDefaultLauncher) {
      config.hide_default_launcher = false;
      config.widget = {
        activator: "#IntercomDefaultWidget"
      }
    } else {
      config.hide_default_launcher = true;
    }
    Intercom("boot", config);
  };

  function toggleShowDefaultLauncher(isEnabled) {
    Intercom('update', {
      'hide_default_launcher': !isEnabled
    });
  }

  function update(user, siteName, permissions, organization) {

    let _permissions = permissions ?
      permissions.map((role) => {
        return _.get(role, 'name', 'Unknown');
      }).join(', ') :
      [];

    let payload: any = user ? {
      email: user.email,
      name: user.displayName,
      user_hash: user.userHash,
      site: siteName,
      permissions: _permissions
    } : {};
    if (!!organization) {
      payload.companies = [
        {
          company_id: organization.id,
          name: organization.name
        }
      ]
    }
    if (!!user.avatar) {
      payload.avatar = {
        type: "avatar",
        image_url: user.avatar
      }
    }
    Intercom("update", payload);
  }

  function shutDown() {
    Intercom('shutdown');
  }

  function show() {
    Intercom('show');
  }

  function hide() {
    Intercom('hide')
  }

  this.$get = () => {
    return {
      initConfigure: this.initConfigure,
      toggleShowDefaultLauncher: toggleShowDefaultLauncher,
      update: update,
      shutDown: shutDown,
      show: show,
      hide: hide
    };
  };
}

angular
  .module('bringoz.admin')
  .provider('intercom', intercomProvider);
